import { APP_RELOAD_REQUESTED_EVENT } from '../../../../hooks/appReload'

export type TimelineExitFlushOrigin =
  | 'visibility-hidden'
  | 'pagehide'
  | 'app-reload-requested'
  | 'unmount'

export function shouldFlushTimelineOnExit(timelineLoaded: boolean, dirty: boolean): boolean {
  return timelineLoaded && dirty
}

interface BindTimelineExitFlushOptions {
  targetWindow: Window
  targetDocument: Document
  flush: (origin: TimelineExitFlushOrigin) => void
}

/** Bind every browser lifecycle boundary that can discard a pending autosave. */
export function bindTimelineExitFlush({
  targetWindow,
  targetDocument,
  flush,
}: BindTimelineExitFlushOptions): () => void {
  const onVisibilityChange = () => {
    if (targetDocument.visibilityState === 'hidden') flush('visibility-hidden')
  }
  const onPageHide = () => flush('pagehide')
  const onAppReloadRequested = () => flush('app-reload-requested')

  targetDocument.addEventListener('visibilitychange', onVisibilityChange)
  targetWindow.addEventListener('pagehide', onPageHide)
  targetWindow.addEventListener(APP_RELOAD_REQUESTED_EVENT, onAppReloadRequested)

  return () => {
    targetDocument.removeEventListener('visibilitychange', onVisibilityChange)
    targetWindow.removeEventListener('pagehide', onPageHide)
    targetWindow.removeEventListener(APP_RELOAD_REQUESTED_EVENT, onAppReloadRequested)
    flush('unmount')
  }
}
